import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Mail, CheckCircle, XCircle } from 'lucide-react';
import { apiPath } from '../api';

const NewsletterUnsubscribe: React.FC = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [status, setStatus] = useState<'loading' | 'ok' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid unsubscribe link.');
      return;
    }
    (async () => {
      try {
        const res = await fetch(
          `${apiPath('/newsletter/unsubscribe')}?token=${encodeURIComponent(token)}`
        );
        const data = await res.json();
        if (data.success) {
          setStatus('ok');
          setMessage(data.message || 'You have been unsubscribed.');
        } else {
          setStatus('error');
          setMessage(data.message || 'Could not unsubscribe.');
        }
      } catch {
        setStatus('error');
        setMessage('Network error. Please try again later.');
      }
    })();
  }, [token]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-8 text-center">
        {status === 'loading' && (
          <>
            <Mail className="w-12 h-12 text-blue-600 mx-auto mb-4 animate-pulse" />
            <p className="text-gray-600">Processing your request…</p>
          </>
        )}
        {status === 'ok' && (
          <>
            <CheckCircle className="w-12 h-12 text-green-600 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-gray-900 mb-2">Unsubscribed</h1>
            <p className="text-gray-600 mb-6">{message}</p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-gray-900 mb-2">Something went wrong</h1>
            <p className="text-gray-600 mb-6">{message}</p>
          </>
        )}
        <Link to="/" className="text-blue-600 font-medium hover:underline">
          Return to store
        </Link>
      </div>
    </div>
  );
};

export default NewsletterUnsubscribe;
